/**
 * Build-time feature flags.
 *
 * `VITE_HIDE_ADMIN_SECTIONS=true` hides the Administration area — Users,
 * Roles & permissions, Pages, and Tenants — from both the sidebar and the
 * router.
 *
 * No build sets it. It was passed by the feature-branch image build while that
 * surface was out of scope for the content team's QA cycle; that ended when
 * Administration went in scope for QA, so every environment now shows
 * everything. The flag is kept because re-hiding the area is a one line build
 * arg, but if you are wondering why Users is missing somewhere, this is not
 * the reason any more — check the Super Admin role requirement in AppLayout
 * instead, which gates the same four entries independently.
 */
export const hideAdminSections =
    import.meta.env.VITE_HIDE_ADMIN_SECTIONS === 'true';

/** Route-name prefixes gated by {@link hideAdminSections}. */
const adminRoutePrefixes = ['users', 'roles', 'pages', 'tenants'];

/**
 * True when `name` belongs to a hidden Administration route (index or show)
 * AND the flag is on. Used by the nav filter and the router guard so both
 * stay in sync from one definition.
 */
export function isHiddenRoute(name: string | null | undefined): boolean {
    if (!hideAdminSections || !name) {
        return false;
    }

    return adminRoutePrefixes.some((prefix) => name === prefix || name.startsWith(`${prefix}.`));
}
